import { isEmpty } from 'lodash'
import React from 'react'
import { Footer, Body as ModalBody } from 'src/components/theme/Models/Modal'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { DescriptionList, Item } from 'src/components/DescriptionList'
import { dates } from 'src/helpers/displayhelpers'
import { FormGroup, FormText, Input, Label } from 'reactstrap'
import { faSend } from '@fortawesome/pro-regular-svg-icons'
import { useEeocContext } from 'src/pages/cat/candidates/Candidate/cards/EEOC/useEeoc'

interface BodyProps {
  id: string
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const [voidReason, setVoidReason] = React.useState<string>('')
  const { candidate, send, sendMode, resendMode, modals: { send: sendModal } } = useEeocContext()
  const errors = []
  const [error, setError] = React.useState<string | null>(null)
  if (isEmpty(candidate?.email)) {
    errors.push('Candidate contact email is missing.')
  }
  if (isEmpty(candidate?._position?.title)) {
    errors.push('Candidate posistion title is missing.')
  }
  if (isEmpty(candidate?.lastFirstName)) {
    errors.push('Candidate full name is missing.')
  }
  if (isEmpty(candidate?.received_on)) {
    errors.push('Candidate received date is missing.')
  }
  if (errors.length > 0) {
    return (
      <ModalBody
        error={{
          error: 'There was an issue sending the EEOC Paperwork.',
          show: false
        }}
      >
        Cannot send EEOC form because of the following errors:
        <ul>
          {errors.map((error, index) => <li key={index}>{error}</li>)}
        </ul>
      </ModalBody>
    )
  }

  const disableSave = errors.length > 0

  const handleSubmit = async (): Promise<void> => {
    if (resendMode && (voidReason === '' || voidReason === null || voidReason === undefined)) {
      setError('Please provide a reason to void the previous document.')
      return
    }
    const data = {
      candidate: id,
      voidReason: voidReason !== '' ? voidReason : undefined
    }
    await send.mutateAsync(data, {
      onSuccess: () => {
        sendModal.toggle()
      }
    })
  }

  return (
    <>
      <ModalBody
        error={{
          error: error ?? 'There was an issue sending the EEOC Paperwork.',
          show: error !== null
        }}
      >
        {sendMode
          ? (
            <p>Send EEOC form to <b>{candidate?.lastFirstName}</b> using the following details?</p>
            )
          : (
            <>
              <p>Resend EEOC form to <b>{candidate?.lastFirstName}</b> using the following details? Please provide a reason to void the previous documents.</p>
              <FormGroup className='mt-3'>
                <Label for='voidReason' className='fw-bold'>Void Reason:</Label>
                <Input
                  type='text'
                  name='voidReason'
                  value={voidReason}
                  onChange={(e) => setVoidReason(e.target.value)}
                />
                <FormText color='muted'>The void reason will be included in a notification to the candidate.</FormText>
              </FormGroup>
            </>
            )}
        <DescriptionList
          className='row-cols-1'
          titleProps={{ lg: 'auto' }}
          valueProps={{ lg: 'auto', className: 'mb-lg-0 mb-md-1 mb-3' }}
        >
          <Item
            id='candidate-name'
            title='Candidate Name'
            value={candidate?.lastFirstName}
          />
          <Item
            id='candidate-email'
            title='Candidate Email'
            value={candidate?.email}
          />
          <Item
            id='candidate-job-title'
            title='Job Title'
            value={candidate?._position?.title}
          />
          <Item
            id='candidate-date-applied'
            title='Date Applied'
            value={dates.dateOnly(candidate?.received_on)}
          />
        </DescriptionList>
      </ModalBody>
      <Footer
        toggle={sendModal.toggle}
        onAction={handleSubmit}
        action={{
          text: sendMode ? 'Send' : 'Resend',
          icon: send.isLoading ? faSpinner : faSend,
          iconProps: { spin: send.isLoading },
          color: 'primary',
          disabled: disableSave || send.isLoading || (resendMode && voidReason === '')
        }}
      />
    </>
  )
}

export default Body
